import { render } from "./DevEnv.vue?vue&type=template&id=09cdfb38&scoped=true"
import script from "./DevEnv.vue?vue&type=script&lang=js"
export * from "./DevEnv.vue?vue&type=script&lang=js"

import "./DevEnv.vue?vue&type=style&index=0&id=09cdfb38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09cdfb38"]])

export default __exports__